export const promptAuth = (message) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("prepRightAuthPrompt", {
      detail: {
        message:
          message ||
          "Create a free account or log in to use this feature."
      }
    })
  );
};

export const requireAuth = (user, message) => {
  if (user) return true;
  promptAuth(message);
  return false;
};
